/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  //  Box,
  // Chip,
  Drawer,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  // Link,
  // Radio,
  // RadioGroup,
  IconButton,
} from "@mui/material";
//import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
//import ClearIcon from "@mui/icons-material/Clear";
import { allfilterdata, fetchAndSetRetailers } from "./alldealsfilterdata";
//import PriceSlider from "src/component/Filters/PriceFilter";
import { CloseRounded } from "@mui/icons-material";

type Props = {
  drawerOpen: boolean;
  setDrawerOpen: CallableFunction;
  toggleDrawer: CallableFunction;
  setSelectedFilterOptions: CallableFunction;
  allFilterData: any;
  handleApplyFilter: CallableFunction;
};
type FilterType = {
  //  category: string;
  brand: string[];
  //dealsAndDiscount: string;
  retailers: string[];
  // priceRange: string;
  discount: string[];
};

const FilterDrawer: React.FC<Props> = ({
  drawerOpen,
  setDrawerOpen,
  toggleDrawer,
  setSelectedFilterOptions,
  allFilterData,
  handleApplyFilter,
}) => {
  const [selectedFilters, setSelectedFilters] = useState<FilterType>({
    //category: "",
    brand: [],
    //dealsAndDiscount: "",
    retailers: [],
    // priceRange: "",
    discount: [],
  });
  const [retailersList, setRetailersList] = useState<any>([]);

  const fetchRetailers = async () => {
    const retailersList = await fetchAndSetRetailers();
    return retailersList;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resolvedRetailers = await fetchRetailers(); // Wait for the data
        // allfilterdata.retailers = resolvedRetailers; // Assign to allfilterdata.retailers

        setRetailersList(resolvedRetailers); // Update state with resolved data
      } catch (error) {
        console.error("Error fetching retailers:", error); // Handle errors
      }
    };
    setRetailersList([]);
    fetchData(); // Call the async function
  }, []);

  useEffect(() => {}, [retailersList]);
  useEffect(() => {
    setSelectedFilterOptions(selectedFilters);
  }, [selectedFilters]);

  // Type-safe key constraint using keyof FilterType
  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    filterType: keyof FilterType
  ) => {
    const { name, checked } = event.target;

    // For array types, update the value properly
    if (Array.isArray(selectedFilters[filterType])) {
      setSelectedFilters((prev) => ({
        ...prev,
        [filterType]: checked
          ? [...(prev[filterType] as string[]), name]
          : (prev[filterType] as string[]).filter((item) => item !== name),
      }));
    }
  };
  /*  const handleRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    filterType: string
  ) => {
    const { value } = event.target;
    setSelectedFilters((prev) => ({
      ...prev,
      [filterType]: value,
    }));
  }; */

  const applyFilters = () => {
    setDrawerOpen(false);
    handleApplyFilter(selectedFilters); // Call the parent handler to process filters
  };

  return (
    <>
      {/* Filter Drawer */}
      <Drawer
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        anchor="top"
        ModalProps={{
          keepMounted: true, // Better open performance on mobile
        }}
        PaperProps={{
          sx: {
            marginTop: "100px", // Starts below the header
            width: "100%", // Full width of the screen
            height: "calc(100vh - 100px)", // Covers the screen below the header
          },
        }}
      >
        <div className="div-filter-drawer-header">
          <Typography
            id="category-section"
            className="filter-drawer-header-text"
            align="left"
          >
            Filters
          </Typography>
          <IconButton
            disableRipple
            aria-label="close modal"
            sx={{
              padding: 0,
              "&:hover": { backgroundColor: "transparent" },
            }}
            onClick={toggleDrawer(false)}
          >
            <CloseRounded />
          </IconButton>
        </div>
        {/* Category Filters using Accordion */}
        {/*   <Accordion defaultExpanded sx={{ border: "none", boxShadow: "none" }}>
          <AccordionSummary>Category</AccordionSummary>
          <AccordionDetails className="filter-options">
            <Link
              href="#"
              color="inherit"
              sx={{ fontFamily: "Poppins", fontSize: "14px" }}
            >
              SmartPhones
            </Link>
          </AccordionDetails>
        </Accordion> */}
        <Accordion style={{ boxShadow: "none" }}>
          <AccordionSummary>Brand</AccordionSummary>
          <AccordionDetails className="filter-options">
            {allFilterData.brand.map((brand: any) => (
              <FormControlLabel
                key={brand}
                control={
                  <Checkbox
                    disableRipple
                    disableFocusRipple
                    name={brand}
                    checked={selectedFilters?.brand.includes(brand)}
                    onChange={(e) => handleCheckboxChange(e, "brand")}
                    sx={{
                      padding: 0,
                      "& .MuiSvgIcon-root": { fontSize: 18 },
                    }}
                  />
                }
                label={brand}
              />
            ))}
          </AccordionDetails>
        </Accordion>

        {/*    <Accordion style={{ boxShadow: "none" }}>
          <AccordionSummary>Deals & Discounts</AccordionSummary>
          <AccordionDetails sx={{ display: "flex", flexDirection: "column" }}>
       
            <RadioGroup
              name="dealsAndDiscount"
              value={selectedFilters.dealsAndDiscount}
              onChange={(e) => handleRadioChange(e, "dealsAndDiscount")}
              sx={{ padding: 0, "& .MuiSvgIcon-root": { fontSize: 18 } }}
            >
              {allfilterdata.dealsAndDiscount.map((deal) => (
                <FormControlLabel
                  sx={{ marginLeft: 0 }}
                  key={deal}
                  value={deal}
                  control={<Radio sx={{ padding: 0 }} />}
                  label={deal}
                />
              ))}
            </RadioGroup>
          </AccordionDetails>
        </Accordion>
 */}
        <Accordion style={{ boxShadow: "none" }}>
          <AccordionSummary>Retailers</AccordionSummary>
          <AccordionDetails sx={{ display: "flex", flexDirection: "column" }}>
            {Object.entries(retailersList).map(([key, value]) => (
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    disableRipple
                    disableFocusRipple
                    name={key}
                    checked={selectedFilters.retailers.includes(key)}
                    onChange={(e) => handleCheckboxChange(e, "retailers")}
                    sx={{
                      padding: 0,
                      "& .MuiSvgIcon-root": { fontSize: 18 },
                    }}
                  />
                }
                label={String(value)}
              />
            ))}
          </AccordionDetails>
        </Accordion>
        {/*   <Accordion style={{ boxShadow: "none" }}>
          <AccordionSummary>Price</AccordionSummary>
          <AccordionDetails>
            <PriceSlider />{" "}
          </AccordionDetails>
        </Accordion> */}
        <Accordion style={{ boxShadow: "none" }}>
          <AccordionSummary>Discount</AccordionSummary>
          <AccordionDetails sx={{ display: "flex", flexDirection: "column" }}>
            {allfilterdata.discount.map((discount) => {
              const [key, value] = Object.entries(discount)[0]; // Extract key and value
              return (
                <FormControlLabel
                  sx={{ marginLeft: 0 }}
                  key={key} // Use the key as the unique identifier
                  control={
                    <Checkbox
                      disableRipple
                      disableFocusRipple
                      name={key} // Use the key as the name
                      checked={selectedFilters.discount.includes(key)} // Check against the key
                      onChange={(e) => handleCheckboxChange(e, "discount")}
                      sx={{
                        padding: 0,
                        "& .MuiSvgIcon-root": { fontSize: 18 },
                      }}
                    />
                  }
                  label={value} // Use the value as the label
                />
              );
            })}
          </AccordionDetails>
        </Accordion>
        <div className="div-apply-button">
          {/* Apply Button */}
          <Button
            className="apply-button"
            sx={{ marginTop: 2 }}
            onClick={applyFilters}
            id="apply-filter-button"
          >
            Apply
          </Button>
        </div>
      </Drawer>
    </>
  );
};

export default FilterDrawer;
